import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GaTrackingEventName, GATrackingEventType, GaTrackingStringConstantEnum } from '../../constants';
import { IOfferLine } from '~shared/modules/cart/models';
import { ApplicationMiniCartEventTypeEnum } from '~shared/modules/application-event/constants';
import get from 'lodash.get';

export class GATrackingRemoveFromCartEvent implements GATrackingEvent {
  constructor(private payload: { id: string; offerLine: IOfferLine; removedItem: string }) {}

  getEventType(): GATrackingEventType {
    return GATrackingEventType.RemoveFromCart;
  }

  getPayload(): GATrackingEventPayload {
    const dimension31 = get(this.payload.offerLine, 'trackingData.dimension31');
    const ecommerce = {
      remove: {
        products: [
          {
            name: this.getOfferName(),
            id: get(this.payload, 'offerLine.item.id', ''),
            price: get(this.payload, 'offerLine.price.offerTotal', 0),
            brand: get(this.payload, '', ''),
            category: this.getCategoryTree(),
            category_id: this.getLeafCategoryId(),
            variant: '',
            dimension27: this.getOfferType(),
            quantity: get(this.payload, 'offerLine.quantity', 0),
            dimension42: get(this.payload.offerLine, 'trackingData.dimension42', 0),
            dimension14: this.getVolumePricingShown(),
            dimension22: this.getOtherOfferShown(),
            dimension12: this.isOnSale(),
            dimension15: this.getSellerName(),
            dimension32: this.getEECLabel(),
            dimension33: this.getRecommendationStatus()
              ? GaTrackingStringConstantEnum.Yes
              : GaTrackingStringConstantEnum.No,
            dimension43: get(this.payload, 'offerLine.trackingData.dimension43', '0'),
            ...(!!dimension31 ? { dimension31 } : {}),
            dimension51: get(this.payload.offerLine, 'trackingData.dimension51', GaTrackingStringConstantEnum.No),
            dimension52: get(this.payload.offerLine, 'trackingData.dimension52', GaTrackingStringConstantEnum.No),
            dimension53: get(this.payload.offerLine, 'trackingData.dimension53', GaTrackingStringConstantEnum.No),
            dimension54: get(this.payload.offerLine, 'trackingData.dimension54', ''),
            ...this.getVasInfo(),
          },
        ],
      },
    };

    return {
      event: GaTrackingEventName.RemoveFromCart,
      label: this.payload.removedItem,
      gtmCustom: { ecommerce },
    };
  }

  private getOfferName() {
    return get(this.payload, 'offerLine.item.name', '');
  }

  private getCategoryTree() {
    const categoryTree = get(this.payload, 'offerLine.trackingData.categoryTree', '');
    return categoryTree.length > 0 ? categoryTree.join('/') : '';
  }

  private getLeafCategoryId() {
    return get(this.payload, 'offerLine.trackingData.leafCategoryId', '');
  }

  private getOfferType() {
    return get(this.payload, 'offerLine.trackingData.offerType', 'other');
  }

  private getVolumePricingShown() {
    return get(this.payload, 'offerLine.trackingData.volumePricingShown', 'No');
  }

  private getOtherOfferShown() {
    return get(this.payload, 'offerLine.trackingData.otherOffersShown', 'No');
  }

  private isOnSale() {
    return get(this.payload, 'offerLine.trackingData.onSale', false);
  }

  private getSellerName() {
    return get(this.payload, 'offerLine.trackingData.sellerName', '');
  }

  private getRecommendationStatus() {
    return get(this.payload, 'offerLine.trackingData.dimension33', 'No');
  }

  private getEECLabel() {
    return get(this.payload, 'offerLine.trackingData.EECLabel', GaTrackingStringConstantEnum.NoEECLabel);
  }

  private getVasInfo() {
    const dimension58 =
      this.payload.removedItem === ApplicationMiniCartEventTypeEnum.removedProductAndServiceLabel
        ? GaTrackingStringConstantEnum.Yes
        : GaTrackingStringConstantEnum.No;

    if (dimension58 === 'yes') {
      return {
        dimension58,
        service_price: this.payload.offerLine.valueAddedServices
          ?.reduce((total, vas) => {
            return total + +vas.price.linePriceNet;
          }, 0)
          .toString(),
      };
    } else {
      return { dimension58 };
    }
  }
}
